<template>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
    <v-flex xs12 sm6 md4 lg6>
        <v-card flat class="mx-auto localizacao" style="border: 1px solid; border-color: #009b9b;border-radius: 10px; background-color: aliceblue;">
        <v-card-text style="margin-bottom: -15px; font-size:18px; color:#828585;"><span class="form-titulo" style="font-size:18px;">Nome:</span> {{financialManagers.firstName}}</v-card-text>
        <v-card-text style="margin-bottom: -15px; font-size:18px; color:#828585;"><span class="form-titulo" style="font-size:18px;">CPF:</span> {{financialManagers.cpf}}</v-card-text>
        <v-card-text v-if="financialManagers.proposalNumber != ''" style="margin-bottom: -15px; font-size:18px; color:#828585;"><span class="form-titulo" style="font-size:18px;">Proposta:</span> {{financialManagers.proposalNumber}}</v-card-text>
        <v-card-text v-if="financialManagers.matricula != ''" style="margin-bottom: -15px; font-size:18px; color:#828585;"><span class="form-titulo" style="font-size:18px;">Matricula:</span> {{financialManagers.matricula}}</v-card-text>
        <v-card-text v-if="status != ''" style="margin-bottom: 0px; font-size:18px; color:#828585;"><span class="form-titulo" style="font-size:18px;">Status da Proposta:</span> {{status}}</v-card-text>
        </v-card> 
    </v-flex> 
    <v-flex xs12 sm12 md12 lg3 
    v-if="!propostaPendente">
    <a >
        <v-card
        @click="print"
        flat
        width="auto"
        min-height="156px"          
        style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
        <v-card-title class="cardpag">
        <span>Baixar Proposta</span>
        </v-card-title> 
        <v-container
              fill-height
              fluid
              pa-1
              justify-center
            >                                             
            <img  src="../Content/images/icon_proposta.png"  width="83px">   
              
        </v-container> 
        </v-card>
        </a>
    </v-flex>
    <v-flex xs12 sm12 md12 lg3 
    v-if="this.sales.boletoId"
    >
    <a>
        <v-card
        @click="baixar2ViaBoleto()"
        :disabled="loadingBoleto"
        flat
        width="auto"
        min-height="156px"          
        style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
        <v-card-title class="cardpag">
        <span>2ª Via do Boleto</span>
        </v-card-title> 
        <v-container
              fill-height
              fluid
              pa-1
              justify-center
            > 
            <v-progress-circular
              v-if="loadingBoleto"              
              :size="60"
              color="primary"
              indeterminate
            ></v-progress-circular>                                            
            <img  v-else src="../Content/images/Codigo.png"  width="110px">   
              
        </v-container> 
        </v-card>
        </a>
    </v-flex>
    </v-layout>
    <br>
    <v-layout row wrap justify-center>
    <v-progress-circular
        :size="50"
        color="#009B99"
        indeterminate
        v-if="loading"
    >        
    </v-progress-circular>
    
    <v-toolbar
          style="border-radius: 10px;"
          class="mb-2"
          color="#009B99"
          dark
          flat
          v-else
        >
        <v-toolbar-title>{{titleProposta}} </v-toolbar-title>
        </v-toolbar>
  </v-layout>    
        <!-- PROPOSTAS EM ANDAMENTO -->
      <v-layout row wrap >
        <v-flex xs12 sm12 md12 lg6 v-if="!propostaPendente && !pagamentoAtivo">
        <v-list style="background-color: transparent;">
        <v-list-tile v-if="pagamentoPendente">
            <v-list-tile-content class="mensageCheck">{{mensage1}}</v-list-tile-content><v-icon color="#009b9b">{{icon}}</v-icon>            
        </v-list-tile>
        <v-list-tile v-else>
            <v-list-tile-content class="mensages">{{mensage1}}</v-list-tile-content><v-icon color="#cc9966">{{iconTimer}}</v-icon>
        </v-list-tile>
        <v-list-tile v-if="pagamentoAnalise">
          <v-list-tile-content class="mensageCheck">{{mensage2}}</v-list-tile-content><v-icon color="#009b9b">{{icon}}</v-icon>            
        </v-list-tile>
        <v-list-tile v-else>
          <v-list-tile-content class="mensageCheck">{{mensage2}}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="pagamentoPendente">
            <v-list-tile-content class="mensages">{{mensage3}}</v-list-tile-content><v-icon color="#cc9966">{{iconTimer}}</v-icon>
        </v-list-tile>
        <v-list-tile v-if="!pagamentoPendente">
            <v-list-tile-content class="mensageCheck">{{mensage3}}</v-list-tile-content>
        </v-list-tile>
        </v-list>
        </v-flex>
     <!-- PROPOSTAS PENDENDTES --> 
        <v-flex xs12 sm12 md12 lg4 v-if="propostaPendente">
          <a @click="concluirProposta()">
              <v-card
              flat
              width="auto"
              min-height="150px"            
              style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
              <v-card-title class="cardpag">
              <span>Concluir Proposta</span>
              </v-card-title> 
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >                                             
                  <img  src="../Content/images/icon_proposta.png"  width="90px">   
                   
              </v-container> 
              </v-card>
              </a>
        </v-flex>

         <!-- PROPOSTAS ATIVAS --> 
         <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                    v-if="pagamentoAtivo"
                  >
        <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg4 >
          <a >
              <v-card
              @click="visualizaContrato()"
              flat
              width="auto"
              min-height="150px"          
              style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
              <v-card-title class="cardpag">
              <span>Termos e Contratos</span>
              </v-card-title> 
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >                                             
                  <img  src="../Content/images/icon_proposta.png"  width="100px">   
                   
              </v-container> 
              </v-card>
              </a>
              </v-flex>
              <v-flex xs12 sm12 md12 lg4>
              <a >
              <v-card
              @click="openCarteirinha()"
              flat
              width="auto" 
              min-height="173px"         
              style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
              <v-card-title class="cardpag">
              <span>Carteirinha</span>
              </v-card-title> 
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >                                             
                  <img  src="../Content/images/icon_carteirinha.png"  width="110px">   
                   
              </v-container> 
              </v-card>
              </a>
        </v-flex>
        <v-flex xs12 sm12 md12 lg4>
              <a href="http://www.primavida.com.br/redecredenciada" target="_blank">
              <v-card
              flat
              width="auto"
              min-height="173px"             
              style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
              <v-card-title class="cardpag">
              <span>Rede Credenciada</span>
              </v-card-title> 
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >                                             
                  <img  src="../Content/images/Icon_Mapa.png"  width="110px">   
                   
              </v-container> 
              </v-card>
              </a>
        </v-flex>
        </v-layout> 
        </v-container>
      </v-layout> 
      <v-btn
      v-if="exibeCancelamento && !pagamentoAtivo"
        style="border-radius: 8px;"
        large                
        dark
        color="error"
        @click="openDialog()"
        >Desistência/Arrependimento
    </v-btn> 
    <v-btn
      v-if="exibeCancelamento && pagamentoAtivo"
        style="border-radius: 8px;"
        large                
        dark
        color="error"
        @click="openDialog()"
        >Desistência/Arrependimento
    </v-btn>
    <v-dialog v-model="dialog" max-width="650px" persistent> 
      <v-card> 
        <v-container
            :fill-height="loadingCancelamento"
            fluid
            justify-center
          >
        <v-progress-circular
                :size="50"
                color="#009B99"
                indeterminate
                v-if="loadingCancelamento"
          ></v-progress-circular>
        <div v-if="cancelada">
        <v-card-title>
          <span class="headline" style="color:#009B99;">Confirmação de Desistência/Arrependimento</span>
        </v-card-title>
        <v-card-text style="color:#546e7a;">Seu pedido de desistência/arrependimento da venda online sob a Proposta/Contrato nº: <span style="font-weight: bold; color:#009B99;">{{financialManagers.proposalNumber}}</span> foi processada com sucesso!</v-card-text>
        <v-card-text style="color:#546e7a;">Protocolo de desistência/arrependimento: <span style="font-weight: bold; color:#009B99;">{{this.protocoloCancelameto}}</span></v-card-text>
        </div>
        </v-container>
        <div
            v-if="exibetextoCancelamento"
          >
        <v-card-title>
          <span class="headline" style="color:#009B99;">Solicitação de Desistência/Arrependimento</span>
        </v-card-title>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-card-text style="font-weight: bold; color:#546e7a;">DIREITO DO ARREPENDIMENTO</v-card-text>
              <v-card-text style="color:#546e7a;">O consumidor terá o prazo de reflexão de 7 (sete) dias corridos, a contar da data de contratação (<span style="font-weight: bold; color:#009B99;">{{this.dataContatacao}}</span>) para informar a desistência, conforme prevê o Art. 49 do Código de Defesa do Consumidor - <a href="http://www.planalto.gov.br/ccivil_03/leis/l8078.htm" target="_blank">Lei 8078/90</a></v-card-text>
            </v-layout>
          </v-container>
          <v-card-actions v-if="!cancelada">
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="cancelarProposta">Confirmar</v-btn>
          <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="close">Sair</v-btn>          
        </v-card-actions>        
        </div>
        <v-card-actions v-if="cancelada">
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="closeConfirmacao">Fechar</v-btn>          
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCarteirinha" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="#009b9b">
          <v-btn icon dark @click="dialogCarteirinha = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Carteirinha</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="dialogCarteirinha = false">Fechar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-img :src="require('../Content/images/carteirinha.jpeg')"></v-img>
      </v-card>
    </v-dialog>
    <loading :active.sync="isLoading" 
        :can-cancel="true" 
        color="#7593b4"
        :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
    <div v-show="true">
    <Proposta ref="proposta"></Proposta>          
    </div>
        </v-container>
</template>

<script>
import Proposta from '../components/proposta.vue'
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl, modelBoleto } from '@/global'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components: {Snackbar, Proposta, Loading},
     data(){
        return{
            token: '',
            idBoleto: '',
            fullPage: true,  
            isLoading: false,
            status: '',
            protocoloCancelameto: '',
            dataContatacao: '',
            dialog: false,
            dialogCarteirinha:false,
            rowsPerPageItems: [1, 12, 18],
            pagination: {
              rowsPerPage: 1
            },
            email: '',
            activeBtn: 'Propostas',
            nomeUsuario: '',
            financialManager: [],
            financialManagers:{
                contratanteTitular: true,
                confirmPassword: '',
                password: '',
                rg: '',
                rgEmitter: '',
                homePhone: '',
                cellPhone: '',
                cellPhone2: '',
                email: '',
                cep: '',
                address: '',
                addressType: '',
                addressTypeName: '',
                addressNumber: '',
                addressComplement: '',
                district: '',
                city: '',
                state: '',
                proposalNumber: '',
                contractNumberS4: '',
                responsibility: '',
                cardNumber: '',
                cardValidity: '',
                cardFlag: '',
                cardDayExpiration: 15,
                dateSignatureContract: '',
                formOfPaymentId: '',
                formOfPayment: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                gender: null,
                maritalStatus: null,
                cpf: '',
                motherName: '',
                susNumber: '',
                plansId: '',
                nsu: '',
                TypeFm: 'FISICA',
                protocoloCancelamento: '',
                vendedor: '',
                matricula: '',
                stageForm: 1  
            },
            dependents: [],
            exibeCancelamento: false,
            propostaPendente: false,
            loading: false,
            loadingCancelamento: false,
            exibetextoCancelamento: true,
            cancelada: false,
            titleProposta: '',
            mensage1: '',
            mensage2: '',
            mensage3: '',
            pagamentoPendente: false,
            pagamentoAnalise: false,
            pagamentoAtivo: false,
            icon: '',
            iconTimer: '',
            proposalNumber: '',
            sales: [],
            loadingBoleto: false,
            cidade: '',
            estado: '',
            bairro: '',
        }
    },
    mounted : function(){
      //document.location.reload(true);
      if(localStorage.getItem('user') != null)
      this.nomeUsuario = localStorage.getItem('user')
      if(sessionStorage.getItem('email') != null)
      this.email = sessionStorage.getItem('email')
      if(localStorage.getItem('proposta') != null)
      this.financialManagers = JSON.parse(localStorage.getItem('proposta'))
      this.carregaProposta()
      this.retornoViaCEP()
    },
    methods: {
       
        async carregaProposta(){
            this.loading = true
           await axios.get(`${baseApiUrl}/FinancialManagers?filter={"where":{"id":"${this.financialManagers.id}"}}`).then(res => {        
            if(res.data != ''){   
                //this.financialManagers = res.data[0] 
                this.financialManager = res.data               
            }
           })           
           /* await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManager[0].plansId}`).then(res => {        
            if(res.data != null){      
            this.financialManager[0].planoSelecionado.push(res.data[0].value,res.data[0].area_atuacao,res.data[0].qualificacao,res.data[0].registro,res.data[0].name,res.data[0].cobertura,res.data[0].id,"",res.data[0].urlMinutaContrato,res.data[0].urlMinutaAditivo,res.data[0].urlManual,res.data[0].urlGuia,res.data[0].urlCobertura)   
            console.log(this.financialManager[0])
            }
          }) */
           await axios.get(`${baseApiUrl}/Sales?filter={"where":{"financialManagerId":"${this.financialManager[0].id}"}}`).then(res => {        
            if(res.data != ''){
              this.sales = res.data[0]
              this.dataContatacao = this.formatDateBrz(res.data[0].salesmanConfirm.substr(0, 10))
              var dat = new Date(res.data[0].salesmanConfirm.substr(0, 10))
              dat.setDate(dat.getDate() + 7)
              if(dat.toISOString().substr(0, 10) >= new Date().toISOString().substr(0, 10))
                this.exibeCancelamento = true
                else
                this.exibeCancelamento = false   
                this.status = res.data[0].status 
                if(this.financialManager[0].TypeFm == 'FISICA'){
                   this.mensage1 = '1 - Aguardando confirmação de pagamento'
                   this.mensage2 = '2 - Pagamento confirmado'
                   this.mensage3 = '3 - Proposta em análise'
                   this.icon = 'check_circle'
                   this.iconTimer = 'hourglass_empty'
                }else
                if(this.financialManager[0].TypeFm == 'SERVIDOR')
                {
                  this.mensage1 = '1 - Aguardando confirmação do orgão averbador'
                   this.mensage2 = '2 - Averbação confirmada'
                   this.mensage3 = '3 - Proposta em análise'
                   this.icon = 'check_circle'
                   this.iconTimer = 'hourglass_empty'
                }
                switch(this.status) {                
                  case 'PAGAMENTO PENDENTE':
                   this.pagamentoPendente = false
                   this.pagamentoAnalise = false
                   this.pagamentoAtivo = false  
                   this.propostaPendente = false                 
                   this.titleProposta = 'Andamento da Proposta' 
                   break
                  case 'EM AVERBAÇÃO':
                   this.pagamentoPendente = false
                   this.pagamentoAnalise = false
                   this.pagamentoAtivo = false  
                   this.propostaPendente = false                 
                   this.titleProposta = 'Andamento da Proposta' 
                   break
                  case 'EM VALIDAÇÃO':
                   this.pagamentoAnalise = true
                   this.pagamentoPendente = true
                   this.pagamentoAtivo = false
                   this.propostaPendente = false
                   this.titleProposta = 'Andamento da Proposta' 
                   break
                  case 'ATIVO':
                   this.pagamentoAtivo = true
                   this.titleProposta = 'Selecione uma opção abaixo' 
                   break
                }                
            }else{
            this.propostaPendente = true
            this.titleProposta = 'Selecione uma opção abaixo'
            }
           }) 
           this.loading = false
        },

        async concluirProposta(){
          //localStorage.clear()
          //sessionStorage.clear('FinancialManager')
          await axios.get(`${baseApiUrl}/Dependents?filter={"where":{"financialManagerId":"${this.financialManager[0].id}"}}`).then(res => {        
            if(res.data != ''){   
                this.dependents = res.data                      
            }
           })
           this.financialManager[0].cep = this.financialManager[0].cep.replace('.','')
           sessionStorage.setItem('FinancialManager',JSON.stringify(this.financialManager[0]))
           //localStorage.setItem('Dependentes',JSON.stringify(this.dependents))
           //console.log('Dependentes', this.dependents)
           switch (this.financialManagers.TypeFm) {
             case 'FISICA':
               this.$router.push({ path: '/contratopf' })
               break;
            case 'SERVIDOR':
               this.$router.push({ path: '/contratosp' })
               break;           
             default:
               break;
           }

        },
        openDialog(){
        this.dialog = true
        this.exibetextoCancelamento = true
      },
        close(){
        this.dialog = false
      },
      closeConfirmacao() {
          this.$store.dispatch('Sair')
          this.$router.push({ path: '/areacliente' })
      },
       async cancelarProposta(){
          this.geraProtocolo()
          this.exibetextoCancelamento = false
          this.cancelada = false
          this.loadingCancelamento = true         
              //this.dialog = false
          //salvar o id do cancelamento no sales e o protocolo no FM
          await axios.post(`${baseApiUrl}FinancialManagers/update?[where][id]=${this.financialManager[0].id}`, {"protocoloCancelamento" : this.protocoloCancelameto})
          await axios.patch(`${baseApiUrl}Sales/${this.sales.id}`, {"cancellationId" : "5d44ef0511d3041d7a33e767", "status": "CANCELADO"})          
              setTimeout(() => {
                this.loadingCancelamento = false
                this.cancelada = true
              }, 3000);          
        },
        formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      geraProtocolo() {
            var data = new Date();
            this.protocoloCancelameto = '416525' + data.getFullYear() + ("0" + (data.getMonth() + 1)).substr(-2) + ("0" + data.getDate()).substr(-2)+Math.floor(10 + Math.random() * 99) + data.getHours() + ("0" +data.getMinutes()).substr(-2);
        },

     async baixar2ViaBoleto(){
       this.loadingBoleto = true
       var situacaoBoleto = ''
        try {
          let res = await axios.get(`${baseApiUrl}/FinancialManagers?filter={"where":{"id":"${this.financialManagers.id}"}}`)
          if(res.data != '')
          {
            situacaoBoleto = res.data[0].situacaoBoleto
            if(situacaoBoleto == "VENCIDO")
              this.gerarBoleto()
            else
            if(situacaoBoleto == "REGISTRADO" || situacaoBoleto == "GERADO")
              {
                try {
                  let resp = await axios.get(`${baseApiUrl}/Sales?filter={"where":{"financialManagerId":"${this.financialManagers.id}"}}`)
                  if(resp.data != '')
                  {
                    this.idBoleto = resp.data[0].boletoId
                    this.imprimirBoleto()                     
                  }
                } catch (error) {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar venda!","ERRO");
                }                           
              }
            else
            if(situacaoBoleto == 'PAGO')
              {
                  this.loadingBoleto = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","Detectamos que o pagamento do boleto já foi efetuado!","ATENÇÃO")
              }
            else
              if(situacaoBoleto == "BAIXADO")
              {
                  this.loadingBoleto = false
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","O boleto para essa proposta encotra-se baixado, para mais informações entre em contato com a Primavida Dental.","ATENÇÃO")
              }
          }
        } catch (error) {
          this.loadingBoleto = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar status do boleto!","ERRO");
        }

        

            
        
      },
      

      //Método para baixar segunda via do boleto 
      async imprimirBoleto(){
        this.loadingBoleto = true
        //var token = ''
        /* //Pegar Token
        try {
              let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
              if(res.data != ''){
                  this.token = res.data.token

              }              
              } catch (error) {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
                  this.close()                 
              } */
        //Baixando Boleto PDF
        await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
           /* Authorization: 'Bearer ' + token, //the token is a variable which holds the token    */        
           'Content-type': 'application/pdf'
        }
        })
        .then(response => {
        //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data], 
              {type: 'application/pdf'});
        //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', 'boleto.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
        //Open the URL on new Window
            window.open(fileURL);        
        })
        .catch(() => {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto","ERRO");
              this.close()   
              return           
              })
      this.loadingBoleto = false
      },
      print() {
          var vm = this;
          vm.$refs.proposta.print();
        },

    async visualizaContrato(){
      await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManager[0].plansId}`).then(res => {        
            if(res.data != null){      
            window.open(res.data[0].urlContrato)
            }
          })      
    },
    openCarteirinha(){
      this.dialogCarteirinha = true
    },

    async retornoViaCEP(){
        if(this.financialManagers.cep != '')
          {
            try {
              let res = await axios.get(`https://viacep.com.br/ws/${this.financialManagers.cep.replace(/[^\d]+/g,'')}/json/`) 
              if(res.data != ''){
                  this.cidade = res.data.localidade
                  this.estado = res.data.uf
                  this.bairro = res.data.bairro
                  if(this.cidade == '' || this.estado == '' || this.bairro == '')
                    this.retornoCEP()
              } 
              else
              {
                var vmcep = this;
                vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                this.cidade = ''
                this.estado = ''
                this.bairro = ''
              }             
              } catch (error) {
                  vmcep = this;
                  vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
                  this.cidade = ''
                  this.estado = ''
                  this.bairro = ''
              }
          }        
      },

      async retornoCEP(){
            try {
              let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep}) 
              if(res.data != ''){
                  this.cidade = res.data.Municipio
                  //this.estado = res.data.Uf
                  this.bairro = res.data.Bairro

              }            
              } catch (error) {
                  var vmcep = this;
                  vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              }         
      },


    async gerarBoleto(){        
        this.loadingBoleto = true
        //this.token = ''
        this.idBoleto = ''
        //Pegar Token
        /* try {
              let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
              if(res.data != ''){
                  this.token = res.data.token

              }              
              } catch (error) {
                  this.loadingBoleto = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
                  this.close()                 
              } */

        //Criando data de vencimeto do boleto
        var datapagvenc = new Date();
        var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
        datapagvenc.setDate(new Date().getDate() + 2)
        //Preencher o campos do model de Boleto
        modelBoleto.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
        modelBoleto.pagadorNome = this.financialManagers.firstName.substr(0, 39)
        modelBoleto.pagadorEndereco = this.financialManagers.address.substr(0, 39) + ', ' + this.financialManagers.addressNumber
        modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
        modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
        modelBoleto.pagadorUf = this.estado
        modelBoleto.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
        modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
        modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
        modelBoleto.valorNominal = parseFloat(this.financialManagers.responsibility)
        modelBoleto.mensagem = 'Referente à segunda via de boleto - Proposta de Número: ' + this.financialManagers.proposalNumber
        modelBoleto.nsu = this.financialManagers.proposalNumber
        modelBoleto.nossoNumero = nossoNum.substr(0,12)
        modelBoleto.seuNumero = nossoNum.substr(0,12)
        
        //Gerando o Boleto e pegando o ID
        try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
              if(res.data != ''){
                  this.idBoleto = res.data.id
                  this.imprimirBoleto()
                  this.atualizaFMeSales()

              }              
              } catch (error) {
                  this.loadingBoleto = false
                  this.vm = this;
                  this.vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
                  //this.close()                 
              }                
        
      },
      async atualizaFMeSales(){
          try {
                await axios.post(`${baseApiUrl}FinancialManagers/update?[where][id]=${this.financialManagers.id}`, {"situacaoBoleto" : "GERADO", "nossoNumero" : modelBoleto.nossoNumero}) 
         
              } catch (error) {
                  vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto no cliente, tente novamente","ATENÇÃO")                   
              }
          try {
                await axios.post(`${baseApiUrl}Sales/update?[where][id]=${this.sales.id}`, {"boletoId" : this.idBoleto}) 
         
              } catch (error) {
                  var vm = this;
                  /* vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto na venda, tente novamente","ATENÇÃO")  */                  
              }
    },
    }

}
</script>

<style>
    .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
      border-radius: 10px;
    }
    .informativo {
    font-size: 25px;
    color: #009b9b;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;    
  }
  .mensageCheck {
    font-weight: 700;
    font-size: 18px;
    color: #c7c7c7;
  }
  .mensages {
    font-weight: 700;
    font-size: 18px;
    color: #797a7a;
  }
  .imagem{
      min-width: 80%;
  }
</style>
